// ---------------------------------------------------------------------------
// Correspondance nom de région -> [lat, lng] du chef-lieu.
// Les clés doivent correspondre exactement au champ `name` de la table `regions`.
// ---------------------------------------------------------------------------
export const REGION_COORDS = {
    Analamanga: [-18.8792, 47.5079],
    Vakinankaratra: [-19.8667, 47.0333],
    Itasy: [-19.0167, 46.7667],
    Bongolava: [-18.7667, 46.05],
    'Haute Matsiatra': [-21.453, 47.0857],
    "Amoron'i Mania": [-20.5333, 47.25],
    'Vatovavy Fitovinany': [-22.15, 48.0167],
    'Atsimo-Atsinanana': [-22.8167, 47.8333],
    Ihorombe: [-22.4, 46.1167],
    'Atsimo-Andrefana': [-23.3516, 43.6708],
    Androy: [-25.1833, 46.0833],
    Anosy: [-25.0333, 46.9833],
    Menabe: [-20.2833, 44.3167],
    Melaky: [-18.0667, 44.0333],
    'Alaotra-Mangoro': [-17.8333, 48.4167],
    Atsinanana: [-18.1492, 49.4023],
    Analanjirofo: [-17.3833, 49.4167],
    Sofia: [-14.8833, 47.9833],
    Boeny: [-15.7167, 46.3167],
    Betsiboka: [-16.9333, 46.8333],
    Diana: [-12.2787, 49.2917],
    Sava: [-14.2667, 50.1667]
}
